import { useState } from 'react';

export interface Open {
  kind: 'open';
}

export interface Closed {
  kind: 'closed';
}

export type OpenableState = Open | Closed;

export type CloseAction = () => void;

export type OpenAction = () => void;

export function useOpenable() {
  const [modalState, setModalState] = useState<OpenableState>({ kind: 'closed' });
  const close: CloseAction = () => {
    setModalState({ kind: 'closed' });
  };
  const open: OpenAction = () => {
    setModalState({ kind: 'open' });
  };

  return {
    modalState,
    close,
    open,
  };
}
